import axios from 'axios'


export const CToken = axios.CancelToken

export const ADMIN_AJAX_URL = '/wp-admin/admin-ajax.php'

export const getCCPAxios = () => {
  let baseURL = ""
  if(process.env.NODE_ENV==="development" || process.env.NODE_ENV==="test"){
    const { REACT_APP_CCP_URL } = process.env
    if(REACT_APP_CCP_URL){
      baseURL = REACT_APP_CCP_URL
    }else {
      if(window && window.app_config && window.app_config.ccp_link){
        baseURL = window.app_config.ccp_link
      }
    }
  }else{
    if(window && window.app_config && window.app_config.ccp_link){
      baseURL = window.app_config.ccp_link
    }
  }
  const ccpAxios = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
      'content-type': 'application/json'
    }
  })
  return ccpAxios
}

export const
  getSiteAxios = () => {
  let baseURL = ""
  if(process.env.NODE_ENV==="development" || process.env.NODE_ENV==="test"){
    const { REACT_APP_SITE_URL } = process.env
    baseURL = REACT_APP_SITE_URL
  }
  if(baseURL){
    return axios.create({
      baseURL: baseURL,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
  }
  return axios
}
